// require('babel-polyfill');

/// static file
require('css/style.scss');

/// require modules
require('js/modules/webfont');
require('js/modules/hero');
require('js/modules/heroScroll');
require('js/modules/logo');
require('js/modules/pagetop');
require('js/modules/spnav');
require('js/modules/gmap');
require('js/modules/search');
require('js/modules/form');
require('js/modules/contact_button');


// WEBPACK FOOTER //
// ./js/main.js